import React from 'react'
// libs
import moment from 'moment'
import { useSnackbar } from 'notistack'
// components
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
// types
import { IIntegrationLink, IntegrationProvider } from 'types/graphql'
// views
import { Card, Chip, CopyButton, ExternalId, ExternalIdRow, Name, Time, Top } from './views'

export interface IntegrationsProps {
  // Read straight off the row the modal was opened from — no query of its own.
  integrations?: IIntegrationLink[] | null
}

const formatDate = (value: string): string => moment(value).format('DD/MM/YYYY [at] h:mma')

// Whether the record is synced to Injury Master, without any surrounding chrome — the caller wraps
// it in whatever collapsible panel fits its form.
const IntegrationCard: React.FC<IntegrationsProps> = ({ integrations }) => {
  const { enqueueSnackbar } = useSnackbar()

  const injuryMasterLink = integrations?.find(({ provider }) => provider === IntegrationProvider.InjuryMaster)

  const copy = (value: string) => () => {
    navigator.clipboard.writeText(value)
    enqueueSnackbar('Copied!', { variant: 'info', autoHideDuration: 1000 })
  }

  return (
    <Card data-testid='integration-card' data-entity-id={IntegrationProvider.InjuryMaster}>
      <Top>
        <Name>Injury Master</Name>
        <Chip $synced={!!injuryMasterLink}>{injuryMasterLink ? 'Synced' : 'Not synced'}</Chip>
        {injuryMasterLink?.syncedAt && <Time>{formatDate(injuryMasterLink.syncedAt)}</Time>}
      </Top>
      {injuryMasterLink?.externalId && (
        <ExternalIdRow>
          <ExternalId title={injuryMasterLink.externalId}>{injuryMasterLink.externalId}</ExternalId>
          <CopyButton type='button' title='Copy Injury Master ID' onClick={copy(injuryMasterLink.externalId)}>
            <ContentCopyIcon />
          </CopyButton>
        </ExternalIdRow>
      )}
    </Card>
  )
}

export default IntegrationCard
